<template>
    <div class="paymentContainer">
    </div>
</template>

<script>

export default {
    name: 'Payment',
    mounted () {
        const queries = this.$route.query
        const transactionPurpose = queries.transactionPurpose
        if (queries && Object.keys(queries).length) {
            if (this.$store.state.dashboard.isLenderContractSigned) {
                // invest screen or Plans screen
                if (this.checkDashboardRoute()) {
                    this.$route.query.showPayUDialog = true
                    this.$router.push({ path: '/dashboard', query: this.$route.query })
                } else if (transactionPurpose === 'portfolio') {
                    this.$router.push({ path: '/select-plan', query: this.$route.query })
                } else if (transactionPurpose === 'funds') {
                    this.$router.push({ path: '/funds', query: this.$route.query })
                }
            } else {
                this.$router.push({ path: '/onboarding', query: this.$route.query })
            }
        }
    },
    methods: {
        checkDashboardRoute () {
            const portfolios = this.$store.state.dashboard.portfolioSummary
            if (portfolios.portfolios.length === 2) {
                if (portfolios.portfolios[0].portfolioType === 'autoInvest' && portfolios.portfolios[0].status !== 1) {
                    return true
                } else if (portfolios.portfolios[1].portfolioType === 'autoInvest' && portfolios.portfolios[1].status !== 1) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped>

</style>
